// Sprint B — small predicates for the new auto-expiry events that the
// backend cron emits. Keep these out of components so banners/timelines
// can share the same checks and we never disagree on what "expired" means.

/**
 * True when an order was auto-cancelled by the pending-orders cron after
 * 30 min — distinguishes it from a customer- or admin-initiated cancel.
 * Backend appends an `order.expired` event right before the `order.cancelled`
 * event when the sweep runs.
 */
export const isExpiredOrder = (order) => {
  if (!order || order.status !== 'cancelled') return false;
  return Array.isArray(order.events)
    && order.events.some((e) => e?.event === 'order.expired');
};

/**
 * Edge case (Sprint B): Paymob webhook lands AFTER the cron expired the
 * order. Money was charged, order is cancelled — backend records a
 * `payment.received_after_expiry` event and admin issues the refund
 * manually. We surface a one-line note on the customer's expiry banner.
 */
export const hasLatePaymentRefundNotice = (order) => {
  if (!order) return false;
  return Array.isArray(order.events)
    && order.events.some((e) => e?.event === 'payment.received_after_expiry');
};
